import { render, staticRenderFns } from "./commission-loading.vue?vue&type=template&id=213f7be4"
import script from "./commission-loading.vue?vue&type=script&lang=js"
export * from "./commission-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports